import { createSelector } from 'reselect';
import { sortLayouts } from '../../../utilities/sort-layouts.esm.js';

var createSortedDisplayLayoutsSelector = function createSortedDisplayLayoutsSelector() {
  return createSelector(function (props) {
    return props.displayLayouts;
  }, sortLayouts);
};

export { createSortedDisplayLayoutsSelector };
//# sourceMappingURL=sorted-display-layouts-selector.esm.js.map
